import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { Account } from '@iw/core/entities';
import { IwDecimalPipe, MaskBalancePipe } from '@iw/core/pipes';

import { CardViewSize } from '../card-view.model';

@Component({
  selector: 'iw-fiat-wallet',
  imports: [
    NgClass,
    IwDecimalPipe,
    IconModule,
    TranslateModule,
    MaskBalancePipe,
  ],
  templateUrl: './fiat-wallet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: contents;
      }
    `,
  ],
})
export class FiatWalletComponent {
  readonly wallet = input<Account>();
  readonly size = input<CardViewSize>();
  readonly iconSize = input<Record<CardViewSize, number>>();
  readonly currentWallet = input<Account>();
  readonly useBalanceMask = input<boolean>(false);
}
